var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "guest-tab", attrs: { id: _vm.componentId } },
    [
      _c("share-invoice-modal", {
        ref: "shareInvoiceModal",
        attrs: { tabId: _vm.tab.id, email: _vm.tabEmail },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "guest-tab-window" },
        [
          !_vm.hideHeader
            ? _c("div", { staticClass: "tab-header" }, [
                _vm.tab.id
                  ? _c("div", { staticClass: "tab-id-header" }, [
                      _c("div", { staticClass: "header-label" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("guest_invoice_number").toUpperCase()
                            ) +
                            "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "header-text" }, [
                        _vm._v(
                          "\n          " + _vm._s(_vm.tab.id) + "\n        "
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "balance-header" }, [
                  _c("div", { staticClass: "header-label" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("guest_balance_due").toUpperCase()) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "header-text" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.formatMoney(_vm.balance_due)) +
                        "\n        "
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.hideHeader && !!_vm.tab.id
            ? _c(
                "div",
                { staticClass: "tab-icons" },
                [
                  _c(
                    "b-tooltip",
                    {
                      attrs: {
                        target: "email-invoice",
                        placement: "top",
                        title: "Send Invoice",
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("invoice_email_invoice")) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tooltip",
                    {
                      attrs: {
                        target: "view-invoice",
                        placement: "top",
                        title: "View Invoice",
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("invoice_view_invoice")) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "fi fi-page-pdf action-icon",
                    attrs: { id: "view-invoice" },
                    on: { click: _vm.viewInvoice },
                  }),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "fi fi-mail action-icon",
                    attrs: { id: "email-invoice" },
                    on: { click: _vm.emailInvoice },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "new-section-window tab-subsection" },
            [
              _c(
                "b-collapse",
                {
                  staticClass: "mt-2",
                  attrs: {
                    id: `${_vm.componentId}-charges-table`,
                    visible: "",
                  },
                },
                [
                  _c("b-table", {
                    staticClass: "tab-info-table",
                    attrs: {
                      "thead-class": "hidden_header",
                      hover: "",
                      fields: _vm.chargesFields,
                      items: _vm.charges,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "cell(descriptor)",
                        fn: function (data) {
                          return [
                            _c("div", [
                              _c("span", { staticClass: "tab-item-name" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(data.item.charge.name) +
                                    "\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.showDescription
                                ? _c(
                                    "span",
                                    { staticClass: "tab-item-description" },
                                    [
                                      _vm._v(
                                        "\n              -  " +
                                          _vm._s(data.item.charge.description) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", { staticClass: "tab-item-name" }, [
                                _c("i", [
                                  _vm._v(" x " + _vm._s(data.item.quantity)),
                                ]),
                              ]),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "cell(charge_rate)",
                        fn: function (data) {
                          return [
                            _c("span", { staticClass: "guest-tab-item" }, [
                              _c("span", { staticClass: "item-total" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.formatMoney(data.item.total)) +
                                    "\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.removeCharge
                                ? _c("i", {
                                    staticClass: "fi fi-x-circle",
                                    staticStyle: { color: "#aa0000" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeCharge(
                                          data.item.charge
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "b-toggle",
                      rawName: "v-b-toggle",
                      value: `${_vm.componentId}-charges-table`,
                      expression: "`${ componentId }-charges-table`",
                    },
                  ],
                  staticClass: "table-collapse",
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "tab-descriptor" }, [
                    _c("b", { staticClass: "collapse-item" }, [
                      _c("span", { staticClass: "descriptor-title" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("invoice_purchases").toUpperCase()) +
                            "\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "descriptor-value" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.formatMoney(this.sub_total)) +
                            "\n            "
                        ),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-collapse",
            {
              staticClass: "mt-2",
              attrs: { id: `${_vm.componentId}-taxes-table` },
            },
            [
              _c("table", { staticClass: "tab-info-table custom-table" }, [
                _c(
                  "tbody",
                  { attrs: { role: "rowgroup" } },
                  _vm._l(_vm.taxes, function (tax, index) {
                    return _c("tr", { key: index, attrs: { role: "row" } }, [
                      _c(
                        "td",
                        {
                          staticClass: "table-descriptor-cell",
                          attrs: { role: "cell", "aria-colindex": "1" },
                        },
                        [
                          _c("div", { staticClass: "table-description" }, [
                            _c("span", { staticClass: "tab-item-name" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(tax.description) +
                                  "\n                "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "table-value-cell",
                          attrs: { role: "cell", "aria-colindex": "2" },
                        },
                        [
                          _c("span", { staticClass: "guest-tab-item" }, [
                            _c(
                              "span",
                              {
                                staticClass: "item-total",
                                staticStyle: {
                                  top: "6px",
                                  position: "relative",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.formatMoney(tax.rate)) +
                                    "\n                "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ])
                  }),
                  0
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "b-toggle",
                  rawName: "v-b-toggle",
                  value: `${_vm.componentId}-taxes-table`,
                  expression: "`${ componentId }-taxes-table`",
                },
              ],
              staticClass: "additionals-window tab-subsection",
            },
            [
              _vm._m(2),
              _vm._v(" "),
              _vm._m(3),
              _vm._v(" "),
              _c("div", { staticClass: "tab-descriptor" }, [
                _c("span", { staticClass: "descriptor-title" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("invoice_taxes_fees").toUpperCase())
                  ),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "descriptor-value" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.formatMoney(_vm.taxes_total)) +
                      "\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "tab-descriptor" }, [
                _c("span", { staticClass: "descriptor-title" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("invoice_tips").toUpperCase()) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "descriptor-value" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.formatMoney(_vm.gratuity)) +
                      "\n        "
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "tab-divider" }),
          _vm._v(" "),
          _c("div", { staticClass: "new-section-window tab-subsection" }, [
            _c("div", { staticClass: "table-collapse" }, [
              _c("div", { staticClass: "tab-descriptor" }, [
                _c("span", { staticClass: "descriptor-title" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("invoice_total").toUpperCase()) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "descriptor-value" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.formatMoney(
                          _vm.sub_total + _vm.gratuity + _vm.taxes_total
                        )
                      ) +
                      "\n          "
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "b-collapse",
            {
              staticClass: "mt-2",
              attrs: { id: `${_vm.componentId}-discounts-table` },
            },
            _vm._l(_vm.discounts, function (discount) {
              return _c(
                "table",
                {
                  key: discount.id,
                  staticClass: "tab-info-table custom-table",
                },
                [
                  _c("tbody", { attrs: { role: "rowgroup" } }, [
                    _c("tr", { attrs: { role: "row" } }, [
                      _c(
                        "td",
                        {
                          staticClass: "table-descriptor-cell",
                          attrs: { role: "cell", "aria-colindex": "1" },
                        },
                        [
                          _c("div", { staticClass: "table-description" }, [
                            _c("span", { staticClass: "tab-item-name" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(discount.date) +
                                  " -\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "tab-item-name" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(discount.description) +
                                  "\n                "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "table-value-cell",
                          attrs: { role: "cell", "aria-colindex": "2" },
                        },
                        [
                          _c("span", { staticClass: "guest-tab-item" }, [
                            _c(
                              "span",
                              {
                                staticClass: "item-total",
                                staticStyle: {
                                  top: "6px",
                                  position: "relative",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.formatMoney(discount.amount)) +
                                    "\n                "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.discount_total > 0
            ? _c(
                "div",
                {
                  staticClass:
                    "new-tab-section new-section-window tab-subsection",
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle",
                          value: `${_vm.componentId}-discounts-table`,
                          expression: "`${ componentId }-discounts-table`",
                        },
                      ],
                      staticClass: "table-collapse",
                    },
                    [
                      _vm._m(4),
                      _vm._v(" "),
                      _vm._m(5),
                      _vm._v(" "),
                      _c("div", { staticClass: "tab-descriptor" }, [
                        _c("b", { staticClass: "collapse-item" }, [
                          _c("span", { staticClass: "descriptor-title" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t("invoice_discounts").toUpperCase()
                                ) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "descriptor-value" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.formatMoney(_vm.discount_total)) +
                                "\n            "
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-collapse",
            {
              staticClass: "mt-2",
              attrs: { id: `${_vm.componentId}-payments-table` },
            },
            _vm._l(_vm.payments, function (payment) {
              return _c(
                "table",
                { key: payment.id, staticClass: "tab-info-table custom-table" },
                [
                  _c("tbody", { attrs: { role: "rowgroup" } }, [
                    _c("tr", { attrs: { role: "row" } }, [
                      _c(
                        "td",
                        {
                          staticClass: "table-descriptor-cell",
                          attrs: { role: "cell", "aria-colindex": "1" },
                        },
                        [
                          _c("div", { staticClass: "table-description" }, [
                            _c("span", { staticClass: "tab-item-name" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(payment.date) +
                                  " -\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "tab-item-name" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(payment.description) +
                                  "\n                "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "table-value-cell",
                          attrs: { role: "cell", "aria-colindex": "2" },
                        },
                        [
                          _c("span", { staticClass: "guest-tab-item" }, [
                            _c(
                              "span",
                              {
                                staticClass: "item-total",
                                staticStyle: {
                                  top: "6px",
                                  position: "relative",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.formatMoney(payment.amount)) +
                                    "\n                "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          0 < _vm.payments.length
            ? _c(
                "div",
                {
                  staticClass:
                    "new-tab-section new-section-window tab-subsection",
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle",
                          value: `${_vm.componentId}-payments-table`,
                          expression: "`${ componentId }-payments-table`",
                        },
                      ],
                      staticClass: "table-collapse",
                    },
                    [
                      _vm._m(6),
                      _vm._v(" "),
                      _vm._m(7),
                      _vm._v(" "),
                      _c("div", { staticClass: "tab-descriptor" }, [
                        _c("b", { staticClass: "collapse-item" }, [
                          _c("span", { staticClass: "descriptor-title" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t("invoice_payments").toUpperCase()
                                ) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "descriptor-value" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.formatMoney(_vm.payment_total)) +
                                "\n            "
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.refunded
            ? _c("div", { staticClass: "tab-subsection" }, [
                _c("div", { staticClass: "table-collapse" }, [
                  _c("div", { staticClass: "tab-descriptor" }, [
                    _c("b", [
                      _c("span", { staticClass: "descriptor-title" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("invoice_refunds").toUpperCase()) +
                            "\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "descriptor-value" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.formatMoney(_vm.refunded)) +
                            "\n            "
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "new-section-window tab-subsection" }, [
            _c("div", { staticClass: "table-collapse" }, [
              _c("div", { staticClass: "tab-descriptor" }, [
                _c("span", { staticClass: "descriptor-title" }, [
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("invoice_balance_due").toUpperCase())),
                  ]),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "descriptor-value" }, [
                  _c("b", [_vm._v(_vm._s(_vm.formatMoney(_vm.balance_due)))]),
                ]),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "when-opened" }, [
      _c("i", { staticClass: "fi fi-minus small" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "when-closed" }, [
      _c("i", { staticClass: "fi fi-plus small" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "when-opened" }, [
      _c("i", { staticClass: "fi fi-minus small" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "when-closed" }, [
      _c("i", { staticClass: "fi fi-plus small" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "when-opened" }, [
      _c("i", { staticClass: "fi fi-minus small" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "when-closed" }, [
      _c("i", { staticClass: "fi fi-plus small" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "when-opened" }, [
      _c("i", { staticClass: "fi fi-minus small" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "when-closed" }, [
      _c("i", { staticClass: "fi fi-plus small" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }